import { findBigintSafe } from "@maven-helper/functions/Misc.function";
import { GetEcoaStudySitesResponse } from "@maven-rest/cdms/ecoa/EcoaSite.dto";
import { EcoaSiteFlax } from "@maven-rest/cdms/ecoa/EcoaSite.flax";
import { Redirect, Route, Switch, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { FxGuard } from "@coralblack/flax";
import { PreProcess } from "@pages/home/PreProcess";
import { Recruit } from "@pages/home/Recruit";
import { PreScreeningSiteContextProvider } from "../PreScreeningSiteContext";
import { useBigIntParam } from "@maven-surface/hooks";

interface PreScreeningRouteProps {}

interface PreScreeningBySiteRouteProps {}

type SiteLocationState = { siteId: bigint | null };

export function PreScreeningRoute(props: PreScreeningRouteProps) {
  const match = useRouteMatch();
  const routeParams = useParams<{ studyId: string }>();
  const { state } = useLocation<SiteLocationState>();

  const studyId = useBigIntParam(routeParams.studyId);

  return (
    <FxGuard
      api={EcoaSiteFlax.getEcoaStudySites({ studyId })}
      render={(resp: GetEcoaStudySitesResponse | null) => {
        if (!resp) return null;

        const selectedSite = (() => {
          if (state?.siteId) {
            return findBigintSafe(resp.studySites, "id", BigInt(state.siteId));
          }

          return (resp.studySites.length === 1 && resp.studySites[0]) || null;
        })();

        return (
          <PreScreeningSiteContextProvider studySites={resp.studySites} selectedSite={selectedSite}>
            <Switch>
              <Route path={`${match.url}/recruit`} render={() => <Recruit studyId={studyId} />} />
              <Route path={`${match.url}/pre`} render={() => <PreProcess studyId={studyId} />} />
              <Redirect from="*" to="/404?pr" />
            </Switch>
          </PreScreeningSiteContextProvider>
        );
      }}
    />
  );
}

export function PreScreeningBySiteRedirect(props: PreScreeningBySiteRouteProps) {
  const routeParams = useParams<{ studyId: string; siteId: string }>();

  const siteId = useBigIntParam(routeParams.siteId);
  const location = useLocation();

  const redirectUrl = location.pathname.split(`/sites/${siteId}`).join("");

  return <Redirect to={{ pathname: redirectUrl, state: { siteId } }} />;
}
